import { render, staticRenderFns } from "./Buttons-Router.vue?vue&type=template&id=24dae731&scoped=true&"
import script from "./Buttons-Router.vue?vue&type=script&lang=js&"
export * from "./Buttons-Router.vue?vue&type=script&lang=js&"
import style0 from "./Buttons-Router.vue?vue&type=style&index=0&id=24dae731&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24dae731",
  null
  
)

export default component.exports